import * as appsettings from './appsettings';

let myTimeoutTimerId: number;
let sessionMinutes: number = 60;
let numberOfSecondsLeft: number = 0;
let initNumberOfSeconds: number = 0;
let myUserId: number | null = null;

// Update Counter method.
function updateCountDown(): void {

    if (numberOfSecondsLeft > 0) {
        numberOfSecondsLeft--;
        myTimeoutTimerId = window.setTimeout(updateCountDown, 1000);
    } else {
        window.location.assign(appsettings.getUrl("Account/Login?timeout=true"));
        numberOfSecondsLeft = initNumberOfSeconds;
        myTimeoutTimerId = window.setTimeout(updateCountDown, 1000);
    }

}

// Init called in the shared _Layout.cshtml (design and live)
export function initialize(HTMLelement: JQuery<HTMLElement>, sessionDuration: number): void {

    if (sessionDuration > 0) {
        sessionMinutes = sessionDuration;
    }

    numberOfSecondsLeft = (sessionMinutes * 60);

    // Set init number (by initialize)
    initNumberOfSeconds = (sessionMinutes * 60);

    // onclick page reset counter
    HTMLelement.on("click", function (e: JQuery.Event) {
        numberOfSecondsLeft = initNumberOfSeconds;
    });

    updateCountDown();
}

// Get number of seconds left in the session.
export function getNumberSecondsLeft(): number {
    return numberOfSecondsLeft;
}

// Reset number of seconds by the saved var: initNumberOfSeconds
export function resetCounter(): void {
    if (myTimeoutTimerId != null) {
        numberOfSecondsLeft = initNumberOfSeconds;
    }
}

export function setMyUserId(userId: number): void {
    myUserId = userId;
}

export function getMyUserId(): number | null {
    return myUserId;
}
